<template>
    <div v-if="options_loaded && passed_filter && filtered_option_list.length > 0 && filtered_option_list[0].value !== null" class="designeroption">
        <div class="stylesoption">
            <div class="form-group" :class="[!valid_selection ? 'has-error' : '']" :data-designer-component-id="component_id">
                <label :for="'question--' + component_id">{{ title }}</label>
                <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                    <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                </select>
                <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                    <option>Loading Options...</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                required: true,
            },
            frame: {
                required: true,
            },
            threshold: {
                required: true,
            },
            cill: {
              required: true,
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.fabricator, this.frame, this.threshold, this.cill);
            },
            url(){
                return '/api/options/' + this.fabricator + '/ramp?frame=' + this.frame + '&threshold=' + this.threshold + '&cill=' + this.cill;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.frame + '_' + this.threshold + '_' + this.cill;
            },
        },
        watch: {
            'cache_key': function (newVal, oldVal) {
                this.update_options();
            },
        }
    }
</script>
